import _ from 'lodash';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { TemplateGalleryCard } from '@common/types';
import TemplateCardListItemsLoadingState from './TemplateCardListItemsLoadingState';
import TemplateCardAdaptive from '../TemplateCard/TemplateCardAdaptive';

type Props = {
  templates?: TemplateGalleryCard[];
  isMobileView: boolean;
};
const TemplateCardListItems = ({ templates, isMobileView }: Props) => {
  const {
    state: { SSRFlow },
  } = useTemplatesContext();

  const haveTemplates = _.size(templates) > 0;

  if (haveTemplates) {
    return (
      <>
        {_.map(templates, (template, index) => (
          <li key={template.id}>
            <TemplateCardAdaptive
              isMobileView={isMobileView}
              template={template}
              forceRender={SSRFlow}
              index={index}
            />
          </li>
        ))}
      </>
    );
  }

  return <TemplateCardListItemsLoadingState isMobileView={isMobileView} />;
};

export default TemplateCardListItems;
